import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const coffeeSubscriptionMatrixDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.coffeeSubscription,
  componentType: LAYOUT_COMPONENT_TYPE.coffeeSubscriptionMatrix,
  registryBlockKey: REGISTRY_BLOCK.presentation.coffeeSubscriptionMatrix,
  displayOrder: 6,
  content: {
    sectionTitle: loc3('Kaffee-Abo', 'Coffee subscription', 'Gói cà phê'),
    supporting: loc3(
      'Bohnen nach Hause — frisch geröstet, flexibel pausierbar.',
      'Beans to your door — freshly roasted, easy to pause.',
      'Hạt về nhà — rang mới, dễ tạm dừng.',
    ),
    plans: loc3(
      'Wöchentlich 250g — 14 €\nMonatlich 1kg — 48 €',
      'Weekly 250g — 14 €\nMonthly 1kg — 48 €',
      'Hàng tuần 250g — 14 €\nHàng tháng 1kg — 48 €',
    ),
    ctaLabel: loc3('Abo anfragen', 'Ask about a plan', 'Hỏi về gói'),
  },
  media: {},
};
